<script setup lang="ts">
import { computed } from 'vue'
import { formatDistanceToNow } from 'date-fns'
import Badge from '../ui/badge/Badge.vue'
import Typography from '../ui/typography/Typography.vue'
import { percentToColor } from '@/lib/converters'

const { percent, count, date } = defineProps<{
  percent: number
  count: number
  date?: string
}>()

const formattedDate = computed(() => (date ? formatDistanceToNow(date, { addSuffix: true }) : null))
</script>

<template>
  <div class="w-full pb-[4px] pt-5">
    <Badge
      class="rounded h-[18px] px-[4px] py-[2px] text-sm font-medium mr-2"
      :style="{ backgroundColor: percentToColor(percent) }"
    >
      {{ percent.toFixed(0) }}%
    </Badge>
    <Typography size="text-13-18" color="secondary" class="font-medium">
      {{ $t('NoLimitHoldem.label.moveSession', { count }) }}
    </Typography>
    <Typography v-if="formattedDate" size="text-12-18" color="inactive">
      ({{ formattedDate }})
    </Typography>
  </div>
</template>

<style scoped></style>
